import { StockLocationEntity } from '../common/entity';

export enum StockLocationRole {
  STOCK_LOCATION_MANAGER = 'STOCK_LOCATION_MANAGER',
  STOCK_LOCATION_SUPERVISOR = 'STOCK_LOCATION_SUPERVISOR',
  STOCK_LOCATION_USER = 'STOCK_LOCATION_USER',
  STOCK_LOCATION_VIEWER = 'STOCK_LOCATION_VIEWER',
}

export class StockLocationRoleAssignment extends StockLocationEntity {
  userId!: string;
  email!: string;
  role!: StockLocationRole;

  constructor(obj: any) {
    super(obj.companyId, obj.stockLocationId);
    Object.assign(this, obj);
  }
}
